import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { AttributeTypeFacetModel } from "@insite/client-framework/Types/ApiModels";
import { ProductListFilterListStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterList";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Trash from "@insite/mobius/Icons/Trash";
import Link from "@insite/mobius/Link";
import Tag from "@insite/mobius/Tag";
import Typography from "@insite/mobius/Typography";
import React, { FC } from "react";

import { css } from "styled-components";

export const filterListStyles: ProductListFilterListStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        `,
    },
    filterText: {
        variant: "h3",
    },
    skipFiltersButtonWrapper: {
        css: css`
            position: relative;
            top: -65px;
            width: 100%;
        `,
    },
    clearAllLink: {
        css: css`
            display: flex;
            width: calc(200% + 20px);
            padding: 5px 10px;
            margin-bottom: 20px;
            border: ${({ theme }) => theme.colors.secondary.contrast} solid 1px;
            border-radius: 100px;

            &:hover {
                border: ${({ theme }) => theme.colors.primary.main} solid 1px;

                span {
                    color: ${({ theme }) => theme.colors.primary.main} !important;
                }
            }

            & > span {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                
                    &[class^="TypographyStyle-sc-"] {
                        font-weight: bold;
                        color: ${({ theme }) => theme.colors.secondary.contrast};
                        flex: 1;
                        text-align: center;
                        margin-top: 4px;
                    }
                }
            }
        `,
    },
    filterTag : {
        css: css`
            align-items: center;
            padding: 8px;
            width: 100%;
            max-width: inherit;
            border-radius: 4px;


            & > span {
                margin: 0 5px 0 0;
            }

            & > button {
                max-width: 15px;
                height: 5px;
                border-radius: 100%;
                background-color: transparent;
                border: ${({ theme }) => theme.colors.secondary.contrast} solid 1px;
                display: flex;
                min-height: 15px;
                align-items: center;
                justify-content: center;

                &:hover {
                    background-color: transparent;
                    border: ${({ theme }) => theme.colors.primary.main} solid 1px;
            
                    span {
                    
                        &[class^="IconWrapper-sc-"] {

                            svg {
                                stroke: ${({ theme }) => theme.colors.primary.main};
                            }
                        }
                    }
                }
            
                span {
                
                    &[class^="IconWrapper-sc-"] {
                        width: 10px;
                        height: 10px;
                    }
                }
            }
        `,
    }
};

const styles = filterListStyles;

export const ProductDetailsFilterList: FC<{attributeTypeFacets: AttributeTypeFacetModel[], searchWithinQueries: string[], clearAllProductFilters: Function, removeAttribute: Function, clickRemoveSearchHandler: Function}> = ({attributeTypeFacets, searchWithinQueries, clearAllProductFilters, removeAttribute, clickRemoveSearchHandler}) => {
    // eslint-disable-next-line react/react-in-jsx-scope

    const anyActiveFilters = attributeTypeFacets?.some(atf =>
        atf.attributeValueFacets?.some(avf => avf.selected),
    ) || (searchWithinQueries && searchWithinQueries.length > 0);

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.filterText} data-test-selector="productListFilterList">
                {translate("Filter")}
            </Typography>
            {searchWithinQueries?.map(s => (
                <Tag
                    key={s}
                    {...styles.filterTag}
                    onDelete={() => clickRemoveSearchHandler(s)}
                    data-test-selector="searchWithinFilter"
                >
                    {translate("Search")}: {s}
                </Tag>
            ))}                    
            {attributeTypeFacets &&
                attributeTypeFacets?.map(attributeTypeFacets => {                                   
                    return attributeTypeFacets.attributeValueFacets
                        ?.filter(facet => facet.selected)
                        .map(facet => {
                        return (
                            <Tag
                                key={facet.attributeValueId}
                                {...styles.filterTag}
                                onDelete={() => {removeAttribute(attributeTypeFacets.attributeTypeId,facet.attributeValueId)}}
                            >
                                {attributeTypeFacets.nameDisplay}: {facet?.valueDisplay}
                            </Tag>
                        );
                    });
                })                
            }
            {anyActiveFilters && (
                <Link
                    {...styles.clearAllLink}
                    onClick={() => clearAllProductFilters()}
                    data-test-selector="productListClearAll"
                >
                    <Typography>{translate("Clear All")}</Typography>                    
                    <Icon src={Trash} size={18} />
                </Link>
            )}
        </StyledWrapper>
    );
}